/** The sync badge: the dot and words next to it, and the save and AI progress bars. */

// ---- toggles
/** Show the words next to the dot (false: only the dot). */
export const SHOW_SYNC_TEXT = true;
/** Show the "Next: ..." list of queued AI jobs. */
export const SHOW_AI_NEXT = true;

// ---- text ({changes} = "1 change" / "3 changes", {seconds} = whole seconds, {list} = job names)
/** Everything saved and in sync. */
export const SYNC_SAVED_TEXT = "All changes saved";
/** Signed out with nothing waiting. */
export const SYNC_SIGNED_OUT_TEXT = "Signed out";
/** Signed out with changes kept on this device. */
export const SYNC_SIGNED_OUT_PENDING_TEXT = "{changes} saved here; sign in to sync";
/** Offline with nothing waiting. */
export const SYNC_OFFLINE_TEXT = "Offline, showing saved copy";
/** Offline with changes kept on this device. */
export const SYNC_OFFLINE_PENDING_TEXT = "Offline, {changes} saved here";
/** Sending changes to the server. */
export const SYNC_SAVING_TEXT = "Saving {changes}";
/** Asking the server for news, nothing to send. */
export const SYNC_CHECKING_TEXT = "Checking for updates";
/** Server not reachable, with changes kept here. {when} is the retry wording below. */
export const SYNC_UNREACHABLE_PENDING_TEXT = "Can't reach the server, {changes} saved here, {when}";
/** Server not reachable, nothing waiting. */
export const SYNC_UNREACHABLE_TEXT = "Can't reach the server, {when}";
/** Retry wording when the next try is known. */
export const SYNC_RETRY_IN_TEXT = "retrying in {seconds}s";
/** Retry wording when it isn't. */
export const SYNC_RETRY_TEXT = "retrying";
/** Changes waiting to be sent while online. */
export const SYNC_WAITING_TEXT = "{changes} waiting";
/** One change, and many changes ({count} = how many). */
export const SYNC_ONE_CHANGE_TEXT = "1 change";
export const SYNC_MANY_CHANGES_TEXT = "{count} changes";
/** Hover and screen-reader label of the badge (it syncs when pressed). */
export const SYNC_NOW_TITLE = "Sync now";
/** Screen-reader label of the save progress bar. */
export const SYNC_SAVING_BAR_LABEL = "Saving";
/** Label of an AI job's bar ({label} = the job, {count} = " (4/16)" or empty). */
export const AI_JOB_TEXT = "AI: {label}{count}";
/** The queued AI jobs line ({list} = first names, {more} = " +2" or empty). */
export const AI_NEXT_TEXT = "Next: {list}{more}";

// ---- timing
/** How often the badge re-reads the clock for the retry countdown, in milliseconds. */
export const SYNC_TICK_MS = 500;
/** A save must take longer than this before its progress bar appears, in milliseconds. */
export const SYNC_BAR_AFTER_MS = 2000;
/** How many queued AI jobs the "Next" line names. */
export const AI_NEXT_SHOWN = 3;
